<template>
  <div class="l-page l-page--step-result-list">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->

    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">RSSからメッセージ作成</div>
        </h2>
      </div>
      <div class="l-main-content">
        <div class="p-step-result">
          <div class="p-message-search">
            <form action="/" method="get">
              <div class="p-message-search-keyword">
                <div class="c-input u-w400">
                  <input
                    v-model="url"
                    type="text"
                    placeholder="ex. https://webpush.jp/rss"
                    class="c-input__item c-input__item--overlay-ico"
                  />
                </div>
                <button type="button" class="c-btn c-btn--gray u-w120 u-h32 u-fs--s" @click="onClick">
                  <p class="c-btn__text">RSS解析</p>
                </button>
              </div>
            </form>
          </div>
          <div class="p-step-result__data">
            <div class="c-loader c-loader"></div>
            <table class="c-table c-table--abtest">
              <thead>
                <tr>
                  <th class="c-table__cell--center">
                    <span class="c-table__text">タイトル</span>
                  </th>
                  <th class="c-table__cell--center">
                    <span class="c-table__text">URL</span>
                  </th>
                  <th class="c-table__cell--center u-w140">
                    <span class="c-table__text"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in results" :key="key">
                  <td class="c-table__cell--left c-table__cell--middle">{{ value.title }}</td>
                  <td class="c-table__cell--left c-table__cell--middle">{{ value.link }}</td>
                  <td class="c-table__cell--center c-table__cell--middle"><a @click="onClickMessageCreate(value.link)">作成</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    csrfToken: String
  },
  data() {
    return {
      results: [],
      url: ''
    }
  },
  mounted: function () {
    const url = localStorage.getItem('rss_url');
    if (url) {
      this.url = url;
      this.onClick();
    }
  },
  methods: {
    onClickMessageCreate: function(url) {
      location.href = '/coins-admin/message/add?type=new&service_type=2&url=' + encodeURIComponent(url);
    },
    onClick: function() {
      const self = this;
      this.fetch(this.url, function(data) {
        if (data) {
          localStorage.setItem('rss_url', self.url);
          self.results = data.data;
        } else {
          self.results = [];
        }
      });
    },
    fetch: function(url, callback) {
      const endpoint = 'https://ipuukofaef2udpzil6wvq6x6pi0sqdmf.lambda-url.ap-northeast-1.on.aws/';
      axios.post(endpoint, {url: url})
        .then(res => {
          callback(res.data);
        })
        .catch(_e => {
          callback(null);
        });
    }
  }
}
</script>
